import useJwt from '@/auth/jwt/useJwt';

export default {
  namespaced: true,
  state: {

  },
  getters: {

  },
  mutations: {

  },
  actions: {
    fetchMsisdnFromMsin({ commit },vm) {
      vm.loading(true);
      useJwt.get('MsisdnFromMsin/'+vm.msin).then(response => {
        vm.msisdn=response.data.result.result;
        vm.loading(false);
      }).catch(error => {
        vm.loading(false);
        console.log(error)
      });
    },
    fetchBalance({ commit },vm) {
      vm.loading(true);
      useJwt.get('getBalance/'+vm.msisdn).then(response => {
        vm.balance=response.data.result.result;
        console.log(vm.balance)
        vm.loading(false);
      }).catch(error => {
        vm.loading(false);
        console.log(error)
      });
    },
    fetchCurrentPackage({ commit },vm) {
      vm.loading(true);
      useJwt.get('getCurrentPackage/'+vm.msisdn).then(response => {
        vm.balance=response.data.result.result;
        console.log(vm.balance)
        vm.loading(false);
      }).catch(error => {
        vm.loading(false);
        console.log(error)
      });
    },
    fetchRechargeHistory({ commit },vm) {
      vm.loading(true);
      useJwt.get('getRechargeHistory',{params:{msisdn:vm.msisdn,from:vm.from,to:vm.to}}).then(response => {
        vm.data=response.data.result.result;
        vm.loading(false);
      }).catch(error => {
        vm.loading(false);
        console.log(error)
      });
    },
    fetchCDRDetail({ commit },vm) {
      vm.loading(true);
      useJwt.get('getCDRDetail',{params:{msisdn:vm.msisdn,from:vm.from,to:vm.to}}).then(response => {
        vm.data=response.data.result.result;
        vm.loading(false);
      }).catch(error => {
        vm.loading(false);
        console.log(error)
      });
    },
    checkApproveStatus({ commit },vm) {
      vm.loading(true);
      useJwt.get('check-approve-status/'+vm.msisdn).then(response => {
        vm.data=response.data.result;
        vm.loading(false);
      }).catch(error => {
        vm.loading(false);
        console.log(error)
      });
    },
  },
}
